import React from 'react';
import { useParams, Link } from 'react-router-dom';
import SEOHead from '../ui/SEOHead';
import PageHero from '../ui/PageHero';
import SidebarInfo from '../ui/SidebarInfo';
import useScrollReveal from '../../hooks/useScrollReveal';
import { SERVICES_DATA, SUB_PAGES_DATA } from '../../data/navigation';
import s from './PageContent.module.css';

export default function ServiceSubPage() {
  useScrollReveal();
  const { serviceSlug, subSlug } = useParams();
  const key  = `${serviceSlug}/${subSlug}`;
  const page = SUB_PAGES_DATA[key];
  const svc  = SERVICES_DATA.find(x => x.slug === serviceSlug);

  const title = page?.title || subSlug.replace(/-/g,' ').replace(/\b\w/g, l => l.toUpperCase());

  return (
    <>
      <SEOHead
        title={page?.seo?.title || `${title} | Celebrity Smile Studio`}
        description={page?.seo?.description || `Learn about ${title} at Celebrity Smile Studio in Flourtown, PA.`}
        keywords={page?.seo?.keywords}
        canonical={`/services/${serviceSlug}/${subSlug}`}
      />
      <PageHero
        eyebrow={page?.eyebrow || svc?.title}
        title={title}
        subtitle={page?.excerpt || `Expert care from experienced dentists at Celebrity Smile Studio.`}
        breadcrumbs={[
          { label: 'Services', path: '/services' },
          { label: svc?.title, path: `/services/${serviceSlug}` },
          { label: title },
        ]}
        cta="Book a Consultation"
        image={page?.image || svc?.image}
      />

      <section className="section">
        <div className="container">
          <div className={s.pageLayout}>

            {/* ── Main content ─────────────────────────────── */}
            <div>
              {/*
               * EDITABLE CONTENT AREA
               * ─────────────────────
               * Edit the `content` field in SUB_PAGES_DATA (navigation.js).
               * Supports any HTML: <p> <ul> <ol> <img> <h2> <h3>
               * <blockquote> <table> <strong> <a> etc.
               */}
              {page?.content ? (
                <div
                  className={s.richContent}
                  dangerouslySetInnerHTML={{ __html: page.content }}
                />
              ) : (
                <div className={s.richContent}>
                  <h2>{title}</h2>
                  <p>At Celebrity Smile Studio, we provide specialized {title.toLowerCase()} treatment with the utmost care and precision. Our experienced team uses advanced technology to ensure your comfort throughout every visit.</p>
                  <p>We understand that every patient has unique needs. That's why we take the time to develop a personalized treatment plan tailored specifically to you.</p>
                </div>
              )}

              <div style={{marginTop:'32px'}}>
                <Link to={`/services/${serviceSlug}`} className="btn btn-outline">
                  ← Back to {svc?.title}
                </Link>
              </div>
            </div>

            {/* ── Sidebar ──────────────────────────────────── */}
            <div className={s.sidebar}>
              <SidebarInfo />
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
